import { InputNumber } from 'antd';
import styled from 'styled-components';
import { colors } from '../../colors';
interface StyledCashInputProps {
  isValid: boolean;
}
export const StyledCashInput = styled.button<StyledCashInputProps>`
  direction: ltr;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 40px;
  border: 1px solid ${(props) => (props.isValid ? colors.grey30 : colors.red30)};
  border-radius: 12px;
  min-width: 146px;
  padding: 0px 16px;
  align-items: center;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  :focus-within {
    border-color: ${(props) => (props.isValid ? colors.grey30 : colors.red30)};
  }
  .ant-input-number-disabled {
    border: none;
    background-color: transparent;
  }
`;
export const StyledInput = styled(InputNumber)`
  font-size: 16px;
  color: ${colors.grey90};
  font-weight: 400;
  .ant-input-number-input::placeholder {
    font-family: 'DM Sans' !important;
    color: ${colors.grey60} !important;
  }
  .ant-input-number-handler-wrap {
    display: none;
  }
  .ant-input-number-input {
    font-family: 'DM Sans' !important;
    padding: 0;
    border: none;
    text-align: right;
    max-width: 70px;
  }
  width: fit-content;
  min-width: 36px;
`;
export const StyledCurrency = styled.div`
  font-size: 16px;
  color: ${colors.grey60};
  font-weight: 400;
`;
